import gql from 'graphql-tag';

const confirmEmailChangeUserMutation = gql`
  mutation ConfirmEmailChangeUserMutation($token: String!) {
    data: confirmEmailChangeUserMutation(token: $token) {
      title
      message
    }
  }
`;

export default confirmEmailChangeUserMutation;
